import { notificationConstants } from '../constants/notification.constants';
import notificationService from '../services/notification.service';
import { alertActions } from './alert.actions';
import { history } from '../helpers';

export const notificationActions = {
  create,
  update,
  remove,  
  fetch,  
  get,
  fetchTypes,
  fetchNotifications,
};

function create (obj) {
  return async dispatch => {
    dispatch(request());

    try {
      const notificationConfig = await notificationService.create(obj);
      dispatch(success(notificationConfig));
      dispatch(alertActions.success("Notificação criada"));
      history.push('/notification/config');
    } catch(error) {
      dispatch(failure(error));
      dispatch(alertActions.error(error));
    }
  };

  function request() { return { type: notificationConstants.CREATE_REQUEST } }
  function success(notificationConfigs) { return { type: notificationConstants.CREATE_SUCCESS, notificationConfigs } }
  function failure(error) { return { type: notificationConstants.CREATE_FAILURE, error } }
}

function update (id, obj) {
  return async dispatch => {
    dispatch(request());

    try {
      const notificationServer = await notificationService.update(id, obj);
      dispatch(success(notificationServer));
      dispatch(alertActions.success("Configuração alterada"));
      history.push('/notification/config');
    } catch(error) {
      dispatch(failure(error));
      dispatch(alertActions.error(error));
    }
  };

  function request() { return { type: notificationConstants.UPDATE_REQUEST } }
  function success(notificationServer) { return { type: notificationConstants.UPDATE_SUCCESS, notificationServer } }
  function failure(error) { return { type: notificationConstants.UPDATE_FAILURE, error } }
}

function remove(id) {
  return async dispatch => {
    dispatch(request());
    try {
      await notificationService.remove(id);
      dispatch(success(true));
    } catch(error) {
      dispatch(failure(error));
      dispatch(alertActions.error(error));
    }
  };

  function request() { return { type: notificationConstants.REMOVE_REQUEST } }
  function success(notificationServer) { return { type: notificationConstants.REMOVE_SUCCESS, notificationServer } }
  function failure(error) { return { type: notificationConstants.REMOVE_FAILURE, error } }
}

function fetch(params) {
  return async dispatch => {
    dispatch(request());

    try {
      const notificationConfigs = await notificationService.fetch(params);

      dispatch(success(notificationConfigs));
    } catch(error) {
      dispatch(failure(error));
      dispatch(alertActions.error(error));
    }
  };

  function request() { return { type: notificationConstants.FETCH_REQUEST } }
  function success(notificationConfigs) { return { type: notificationConstants.FETCH_SUCCESS, notificationConfigs } }
  function failure(error) { return { type: notificationConstants.FETCH_FAILURE, error } }
}

function get(id) {
  return async dispatch => {
    dispatch(request());

    try {
      const notificationConfig = await notificationService.get(id);
      dispatch(success(notificationConfig));
    } catch(error) {
      dispatch(failure(error));
      dispatch(alertActions.error(error));
    }
  };

  function request() { return { type: notificationConstants.GET_REQUEST } }
  function success(notificationConfig) { return { type: notificationConstants.GET_SUCCESS, notificationConfig } }
  function failure(error) { return { type: notificationConstants.GET_FAILURE, error } }
}

function fetchTypes(params) {
  return async dispatch => {
    dispatch(request());

    try {
      const notificationTypes = await notificationService.fetchTypes(params);

      dispatch(success(notificationTypes));
    } catch(error) {
      dispatch(failure(error));
      dispatch(alertActions.error(error));
    }
  };

  function request() { return { type: notificationConstants.FETCH_TYPES_REQUEST } }
  function success(notificationTypes) { return { type: notificationConstants.FETCH_TYPES_SUCCESS, notificationTypes } }
  function failure(error) { return { type: notificationConstants.FETCH_TYPES_FAILURE, error } }
}

function fetchNotifications(params) {
  return async dispatch => {
    dispatch(request());

    try {
      const notifications = await notificationService.fetchNotifications(params);

      dispatch(success(notifications));
    } catch(error) {
      dispatch(failure(error));
      dispatch(alertActions.error(error));
    }
  };

  function request() { return { type: notificationConstants.FETCH_NOTIFICATIONS_REQUEST } }
  function success(notifications) { return { type: notificationConstants.FETCH_NOTIFICATIONS_SUCCESS, notifications } }
  function failure(error) { return { type: notificationConstants.FETCH_NOTIFICATIONS_FAILURE, error } }
}


